export const GET_USER = "GET_USER";
export const GET_USER_SUCCESS = "GET_USER_SUCCESS";
export const GET_USER_ERROR = "GET_USER_ERROR";

export const GET_USER_PAYMENT_DETAIL = "GET_USER_PAYMENT_DETAIL";
export const GET_USER_PAYMENT_DETAIL_SUCCESS =
  "GET_USER_PAYMENT_DETAIL_SUCCESS";
export const GET_USER_PAYMENT_DETAIL_ERROR = "GET_USER_PAYMENT_DETAIL_ERROR";
